import React, { useEffect, useState } from "react";
import "./index.css";
import Img_Banner from "../../../assets/Images/case-8.jpg";
import analyze from "../../../assets/Images/platform/analyzing.png";
import plan from "../../../assets/Images/platform/plan.png";
import develop from "../../../assets/Images/platform/development.png";
import test from "../../../assets/Images/platform/test.png";
import launch from "../../../assets/Images/platform/launch.png";
import grow from "../../../assets/Images/platform/growth.png";
import LoginAPI from "../../../api/adminlogin";
import { useParams } from "react-router-dom";
import { baseURL } from "../../../api/api";
// import ourwork from "../../../assets/Images/Asset 1q.png";

function ViewProduct_Component() {
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [productname, setProductName] = useState("");
  const [categoryname, setCategoryName] = useState("");
  const [main_description, setDescription] = useState("");
  const [gallery, setGallery] = useState([]);
  const [mainImg, setmainImg] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [platforms, setPlatforms] = useState([]);
  const [panels, setPanels] = useState([]);
  const [features, setFeatures] = useState([]);
  const [benefits, setBenefits] = useState([]);

  const ProductGet = async () => {
    setLoading(true);

    try {
      const response = await LoginAPI.productGet(id);

      if (response.apiStatus.code == 200) {
        const data = response.responseData.product;
        const galleryImg = data.gallery_images || [];

        setGallery(galleryImg);

        setmainImg(`${baseURL}${data.main_image}`);
        setSelectedIndex(-1);

        setProductName(data.product_name);
        setCategoryName(data.category);
        setDescription(data.product_description);
        setmainImg(`${baseURL}${data.main_image}`);
        setPlatforms(data.platforms || []);
        setPanels(data.panels || []);
        setFeatures(data.features || []);
        setBenefits(data.benefits || []);
      }
    } catch {}
  };
  useEffect(() => {
    ProductGet();
  }, [id]);

  const handleImageClick = (img, index) => {
    const clickedImgFull = `${baseURL}${img}`;

    const currentMain = mainImg.replace(baseURL, "");

    const newGallery = [...gallery];
    newGallery[index] = currentMain;

    setGallery(newGallery);
    setmainImg(clickedImgFull);
    setSelectedIndex(index);
  };

  return (
    <>
      <div className="container">
        <div className="view_product_container_1">
          <h6>{categoryname}</h6>
          <h4>{productname}</h4>
          <p>{main_description}</p>
        </div>

        <div className="row">
          <div className="col-md-8">
            <img src={mainImg} alt="" className="w-100" />
          </div>
          <div className="col-md-4">
            <div className="sidebar-card mt-0 text-start d-none d-lg-block">
              <h3>Gallery Images</h3>

              <div className="row">
                <div className="gallery-img-detail-multi">
                  <div className="row">
                    {(gallery || []).map((img, index) => (
                      <div className="col-md-4 mt-4" key={index}>
                        <div
                          className={`card border-0 rounded-0 position-relative ${
                            selectedIndex === index ? "gallery-selected" : ""
                          }`}
                          style={{ cursor: "pointer" }}
                          onClick={() => handleImageClick(img, index)}
                        >
                          <img
                            src={`${baseURL}${img}`}
                            className="rounded w-100"
                            alt=""
                          />

                          {selectedIndex === index && (
                            <i className="fas fa-check-circle gallery-tick"></i>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div class="sidebar-card categories text-start">
              <h3>Technologies :</h3>
              <div className="row">
                {platforms.map((item, index) => (
                  <div className="col-3 mb-3" key={index}>
                    <div className="card border-0 text-center p-1">
                      <img
                        src={`${baseURL}${item.image_path}`}
                        // alt={item.technology_name}
                        style={{ height: "60px" }}
                      />
                      <p className="mt-2 small">{item.technology_name}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="view_product_container_2 mt-5">
          <h6>
            Explore {panels.length} Unique Panels With User Oriented Features
            From
          </h6>
          <h4>Hermon Solutions Software Development Company in India</h4>

          <ul className="nav custom-tabs mt-5">
            {panels.map((panel, index) => (
              <li className="nav-item" key={index}>
                <button
                  className={`nav-link ${index === 0 ? "active" : ""}`}
                  data-bs-toggle="tab"
                  data-bs-target={`#panel-${index}`}
                >
                  {panel.panel_name} Panel
                </button>
              </li>
            ))}
          </ul>

          <div className="tab-content custom-tab-content text-start">
            {panels.map((panel, index) => (
              <div
                key={index}
                className={`tab-pane fade ${index === 0 ? "show active" : ""}`}
                id={`panel-${index}`}
              >
                <h4>{panel.panel_name} Panel</h4>
                <ul>
                  {(panel.panel_features || []).map((feature, i) => (
                    <li key={feature?.uaf_id || i}>
                      <i className="fa-solid fa-check"></i> {feature?.uaf_name}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="product_view_our_work mt-5 pb-4 pt-3">
        <div className="container pt-4">
          <h4>How Do we Work?</h4>
          <h6>
            If you are looking for the best Learning Management Software
            Development Services Provider in India, you have succeeded in your
            search. Talk to the leading LMS service providers regarding your B2B
            LMS Software services requirements. Our expert Hermon Solutions
            software developers in India listen carefully to your concerns and
            assure to provide the same to help meet your business goals.
          </h6>
        </div>
        <div className="container mt-4 p-4">
          <div className="row g-0 justify-content-center">
            <div className="col-md-1">
              <div className="card text-center p-3">
                <div>
                  <img src={analyze} alt="" width="70px" />
                </div>
                <h6 className="view-product-card-text">Analyze</h6>
              </div>
            </div>
            <div className="col-md-1 pt-5">
              <i class="fa-solid fa-arrow-right view-product-work-arrow"></i>
            </div>
            <div className="col-md-1">
              <div className="card text-center p-3">
                <div>
                  <img src={plan} alt="" width="70px" />
                </div>
                <h6 className="view-product-card-text">Plan</h6>
              </div>
            </div>
            <div className="col-md-1 pt-5">
              <i class="fa-solid fa-arrow-right view-product-work-arrow"></i>
            </div>
            <div className="col-md-1">
              <div className="card text-center p-3">
                <div>
                  <img src={develop} alt="" width="70px" />
                </div>
                <h6 className="view-product-card-text">Develop</h6>
              </div>
            </div>
            <div className="col-md-1 pt-5">
              <i class="fa-solid fa-arrow-right view-product-work-arrow"></i>
            </div>
            <div className="col-md-1">
              <div className="card text-center p-3">
                <div>
                  <img src={test} alt="" width="70px" />
                </div>
                <h6 className="view-product-card-text">Test</h6>
              </div>
            </div>
            <div className="col-md-1 pt-5">
              <i class="fa-solid fa-arrow-right view-product-work-arrow"></i>
            </div>
            <div className="col-md-1">
              <div className="card text-center p-3">
                <div>
                  <img src={launch} alt="" width="70px" />
                </div>
                <h6 className="view-product-card-text">Launch</h6>
              </div>
            </div>
            <div className="col-md-1 pt-5">
              <i class="fa-solid fa-arrow-right view-product-work-arrow"></i>
            </div>
            <div className="col-md-1">
              <div className="card text-center p-3">
                <div>
                  <img src={grow} alt="" width="70px" />
                </div>
                <h6 className="view-product-card-text">Grow</h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="view_product_container_3 mt-5">
          <h4>
            Features of <span>{productname}</span> System
          </h4>
          <h6>
            We are one of the top LMS software companies in India that deliver
            affordable digital learning management system software, and training
            management software systems that are fully packed with exceptional
            user-centric features.
          </h6>

          <div className="row text-start">
            {features.map((item, index) => (
              <div className="col-md-6 mt-4" key={index}>
                <div className="row">
                  <div className="col-md-2">
                    <img
                      src={`${baseURL}${item.image}`}
                      alt=""
                      className="w-100"
                    />
                  </div>
                  <div className="col-md-10">
                    <h6 className="view-features-header">
                      {item.feature_name}
                    </h6>
                    <p className="view-features-para">
                      {item.feature_description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="view_product_benefit_section p-5 mt-5">
        <div className="container">
          <div className="row text-start">
            <div className="col-md-12">
              {" "}
              <h4 className="view_product_benefit_header_head">
                Benefits of Our Online Learning Management System
              </h4>
            </div>
            {benefits.map((item, index) => (
              <div className="col-md-3 mt-4" key={index}>
                <div className="card p-4 view_benefit_card_all h-100">
                  <img
                    src={`${baseURL}${item.image}`}
                    alt=""
                    style={{ width: "100px", height: "80px" }}
                  />
                  <h6>{item.benefit_name}</h6>
                  <hr />
                  <p>{item.benefit_description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewProduct_Component;
